import CryptoJS from "crypto-js";

export const decrypt = (cipherString: string, useHashing: boolean) => {
  try {
    const secret = "abcdefghijklmnop";
    const key = CryptoJS.enc.Utf8.parse(secret);

    const encryptedText = cipherString; // Coloque o texto cifrado gerado pelo C#
    const cipherBytes = CryptoJS.enc.Base64.parse(encryptedText);

    const decryptedBytes = CryptoJS.AES.decrypt(
      { ciphertext: cipherBytes },
      key,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return decryptedText;
  } catch (error) {
    console.error("Erro ao descriptografar:", error);
  }
};
